import type { Modality } from './types';

export interface ZoneDef {
  id: 'Z1' | 'Z2' | 'Z3' | 'Z4' | 'Z5' | 'Z6_7';
  name: string;
  color: string;
  develops: string;
}

export const ZONES: ZoneDef[] = [
  { id: 'Z1', name: 'Active Recovery', color: '#6B6360', develops: 'Improves oxygen supply to muscles and aids recovery' },
  { id: 'Z2', name: 'Base Training', color: '#5C8A3A', develops: 'Builds mitochondrial and capillary density of muscle fibres' },
  { id: 'Z3', name: 'Tempo', color: '#2E6F8E', develops: 'Improves cardiorespiratory health, cardiac output and lactate oxidation' },
  { id: 'Z4', name: 'Threshold', color: '#C97A1F', develops: 'Builds resistance to fatigue at high intensity' },
  { id: 'Z5', name: 'VO₂max', color: '#AB292C', develops: 'Maximises oxygen utilisation and metabolic function' },
  { id: 'Z6_7', name: 'Power', color: '#7A1D1F', develops: 'Develops maximal power-generation capability' },
];

export interface IntensityDomainDef {
  name: string;
  color: string;
  desc: string;
}

export const INTENSITY_DOMAINS: IntensityDomainDef[] = [
  {
    name: 'Moderate',
    color: '#5C8A3A',
    desc: 'A metabolic steady state at the cellular level — the muscles handle the workload and recycle lactate without it accumulating in the blood.',
  },
  {
    name: 'Heavy',
    color: '#C97A1F',
    desc: 'A metabolic steady state at the systemic level. The effort can no longer be fully absorbed by the muscles, so lactate accumulates above resting values.',
  },
  {
    name: 'Severe',
    color: '#AB292C',
    desc: 'A loss of internal homeostasis. Lactate accumulates exponentially with no steady state, and VO₂max is reached if the effort is prolonged.',
  },
];

export interface ThresholdMetaDef {
  name: string;
  subInitial: string;
  subRetest: string;
  color: string;
}

export const THRESHOLD_META: { t1: ThresholdMetaDef; t2: ThresholdMetaDef } = {
  t1: { name: 'Threshold 1', subInitial: 'Aerobic · Moderate → Heavy', subRetest: 'Moderate → Heavy', color: '#C97A1F' },
  t2: { name: 'Threshold 2', subInitial: 'Anaerobic · Heavy → Severe', subRetest: 'Heavy → Severe', color: '#AB292C' },
};

export function unitsForModality(
  m: Modality
): { intensityLabel: string; intensityUnit: string; showPace: boolean } {
  if (m === 'treadmill') {
    return { intensityLabel: 'Speed', intensityUnit: 'km/h', showPace: true };
  }
  return { intensityLabel: 'Power', intensityUnit: 'W', showPace: false };
}
